import { api_host } from '../constants'
import { apiFetch } from './apiRequestHandler'

export const getPermissions = async () => {
  return await apiFetch(`${api_host}/permissions/list`)
}

export const createPermission = async (data) => {
  return await apiFetch(`${api_host}/permissions`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
}

export const deletePermission = async (id) => {
  return await apiFetch(`${api_host}/permissions/${id}`, {
    method: 'DELETE'
  })
}
